import config from '../../config'
import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import { IUseUpdateMutation, IDeleteFn, ITrainingCategory, IGetPutRequest } from '../../interfaces'

const getToggleActiveTrainingCategoryMutationRequest: IGetPutRequest = params => {
  return {
    method: 'put',
    url: `${config.baseUrl}/TrainingCategories/`,
  }
}

const useToggleActiveTrainingCategoryMutation: IUseUpdateMutation<ITrainingCategory, number> = (params, options = {}) => {
  const request = useMemo(() => getToggleActiveTrainingCategoryMutationRequest(params), [params])

  const updateTraining: IDeleteFn<ITrainingCategory> = useCallback(
    async id => axios({ ...request, url: request.url + id + '/toggle-is-active' }).then(res => res.data),
    [request],
  )

  const response = useMutation<ITrainingCategory, Error, any>({ mutationFn: updateTraining, ...options })

  return response
}

export default useToggleActiveTrainingCategoryMutation
